import { Form } from 'react-bootstrap';
import Clipboard from "components/workflow/generic/controls/common/clipboard";

/**
 * FieldLabel — a settings-form field label, optionally with a copy-to-clipboard button beside it.
 *
 * The read-only identity fields on the person / organization / blob profile pages (alias, id, email)
 * all want the same thing: a bold label with a copy affordance for the value below it. That markup —
 * a flex row, a nudged-down label span, two non-breaking spaces, a <Clipboard> — was being hand-copied
 * per field per page, and had already drifted (some fields had the copy button, some didn't; the
 * nudge was written as a hyphenated CSS property React warns about).
 *
 * `copy` is the VALUE to place on the clipboard, not a flag: when it is absent the label renders bare,
 * without the flex row, since the 6px nudge only exists to center the text against the button.
 */
export default function FieldLabel({ label, copy }) {
  if ( !copy ) {
    return (
      <Form.Label>
        <strong>{label}</strong>
      </Form.Label>
    );
  }
  return (
    <Form.Label>
      <div className="d-flex">
        <span style={{marginTop: "6px"}}>
          <strong>{label}</strong>
        </span>
        &nbsp;&nbsp;
        <Clipboard text={copy} />
      </div>
    </Form.Label>
  );
}
